

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.c26f02c0.js","_app/immutable/chunks/scheduler.44d63395.js","_app/immutable/chunks/index.ddc1e9bc.js","_app/immutable/chunks/singletons.a6dca536.js","_app/immutable/chunks/index.651c7174.js"];
export const stylesheets = [];
export const fonts = [];
